import { makeStyles, Spinner, Text, tokens } from '@fluentui/react-components';

import { spacing } from '@/theme/tokens';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.xxxxl,
    gap: spacing.s,
  },
  label: {
    color: tokens.colorNeutralForeground3,
  },
});

interface LoadingStateProps {
  label?: string;
}

export function LoadingState({ label = 'Loading…' }: LoadingStateProps) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Spinner size="medium" />
      <Text size={200} className={classes.label}>
        {label}
      </Text>
    </div>
  );
}
